import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import Button from "../../../../components/Common/Button/Button";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../../hooks/useFetchData";
import {
  getUserClassAssignmentActionHandler,
  putAssignedClassesActionHandler,
} from "../../../../store/actions/actionHandlers/distributeActionHandler";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { recallShotclasses } from "../../../../utils/mainTabs/distribute/recallShotclasses";
import classes from "./RecallShotclassesTable.module.scss";
import { FormattedMessage } from "react-intl";
import { recallSelective } from "../../../../utils/mainTabs/distribute/recallSelective";

const RecallShotclassesTable = ({
  fromDate,
  toDate,
  tenantName,
  searchClick,
  selectedUserClassAndNameObj,
  setSelectedUserClassAndNameObj,
}) => {
  const pageSize = 10;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [tableColumns, setTableColumns] = useState([]);
  const { columns } = recallShotclasses;
  const [selectedRowData, setselectedRowData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [rowData, setRowData] = useState([]);
  const {
    updatedData,
    totalRows,
    loading,
    handleCurrentPage,
    setData,
    setUpdatedData,
    handleSearchQuery,
    handleSetOptionalParams,
  } = useFetchData(
    (
      searchQuery,
      pageNum,
      pageSize,
      setData,
      setUpdatedData,
      setTotalRows,
      selectedUserClassAndNameObj
    ) =>
      getUserClassAssignmentActionHandler(
        searchQuery,
        pageNum,
        pageSize,
        setData,
        setUpdatedData,
        setTotalRows,
        selectedUserClassAndNameObj?.class
      ),
    pageSize,
    selectedUserClassAndNameObj
  );
  const handleSelectClick = useCallback(
    (row) => {
      setRowData(row);
      setselectedRowData([]);
      navigate(recallSelective?.path(tenantName));
      setSelectedUserClassAndNameObj((prev) => {
        return {
          ...prev,
          user: {
            classId: row?.ClassId,
            className: row?.ClassName,
            userId: 0,
            type: "user",
          },
        };
      });
    },
    [navigate, tenantName, setSelectedUserClassAndNameObj]
  );

  useEffect(() => {
    let newTableColumns = [];
    newTableColumns = columns(handleSelectClick, navigate, tenantName);
    setTableColumns(newTableColumns);
  }, [columns, navigate, location, rowData, tenantName, handleSelectClick]);

  useEffect(() => {
    const dataArr = [];
    updatedData?.forEach((data) => {
      if (data?.checked) dataArr.push(data);
    });
    setselectedRowData(dataArr);
  }, [updatedData]);

  const handleSubmit = () => {
    const classIds = selectedRowData?.map((data) => {
      return data?.ClassId;
    });
    const obj = {
      ClassIds: classIds || [],
      FromDate: fromDate ? moment(fromDate).format("DD/MM/YYYY") : "",
      ToDate: toDate ? moment(toDate).format("DD/MM/YYYY") : "",
    };
    setLoader(true);
    dispatch(putAssignedClassesActionHandler(obj)).then((response) => {
      setLoader(false);
      if (response.status === 200) {
        handleSearchQuery();
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            "Shotclasses are Recalled Successfully for Selected Classes"
          )
        );
      }
    });
  };

  useEffect(() => {
    if (searchClick > 1) {
      handleSetOptionalParams(selectedUserClassAndNameObj);
    }
  }, [searchClick]);

  return (
    <div className={classes.recallShotclasses}>
      {updatedData?.length === 0 && !loading ? (
        <BoxLayout>
          <div className={classes.noRecordFound}>
            <FormattedMessage id="DISRTIBUTE_NORESULT_TEXT" />
          </div>
        </BoxLayout>
      ) : (
        <DataTable
          columns={tableColumns}
          data={updatedData}
          totalRows={totalRows}
          loading={loading}
          uniqueFieldName={"ClassId"}
          selectableRows
          fetchMoreData={handleCurrentPage}
          setDefaultData={setData}
          setData={setUpdatedData}
        />
      )}
      <div className={classes.recallBtn}>
        <Button
          type="submit"
          label={<FormattedMessage id="ARCHIVE_TEXT" />}
          dark
          width="11"
          height="5"
          disabled={selectedRowData?.length === 0}
          backgroundColor={loader ? undefined : "#D31B61"}
          loading={loader}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default RecallShotclassesTable;
